export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/banners.2ff5868.svg";